"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pieve-di-cadore": {
    "dba84955": [{
      "hkey": "d33448ce",
      "slug": "nebbiu-di-cadore",
      "name": "Nebbiù di Cadore",
      "primary": true,
      "skipSearch": false
    }],
    "nebbiu": [{
      "hkey": "d33448ce",
      "slug": "nebbiu-di-cadore",
      "name": "Nebbiù di Cadore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c605c7c2": [{
      "hkey": "a3faba02",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "pieve": [{
      "hkey": "a3faba02",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c83c9670": [{
      "hkey": "042644c7",
      "slug": "sottocastello-di-cadore",
      "name": "Sottocastello di Cadore",
      "primary": true,
      "skipSearch": false
    }],
    "sottocastello": [{
      "hkey": "042644c7",
      "slug": "sottocastello-di-cadore",
      "name": "Sottocastello di Cadore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;